import api from './client';
import type { Organization } from '../types/organization';

export async function listOrganizations(format: 'flat' | 'tree' = 'flat') {
  const url = format === 'tree' ? '/organizations/tree' : '/organizations';
  const res = await api.get<Organization[]>(url);
  return res.data;
}

export async function getOrganization(id: string) {
  const res = await api.get<Organization>(`/organizations/${id}`);
  return res.data;
}

export async function getOrganizationChildren(id: string) {
  const res = await api.get<Organization[]>(`/organizations/${id}/children`);
  return res.data;
}

export async function createOrganization(data: {
  name: string;
  code: string;
  level: 'federal' | 'canton' | 'commune';
  parent_id?: string | null;
  metadata_?: Record<string, unknown>;
}) {
  const res = await api.post<Organization>('/organizations', data);
  return res.data;
}

export async function updateOrganization(id: string, data: Partial<Organization>) {
  const res = await api.put<Organization>(`/organizations/${id}`, data);
  return res.data;
}

export async function deleteOrganization(id: string) {
  const res = await api.delete(`/organizations/${id}`);
  return res.data;
}
